/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Button, Flex, Heading } from "@aws-amplify/ui-react";
import CommentCard from "./CommentCard";
export default function HealthRecordsFamilyHistory(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="24px"
      direction="column"
      width="688px"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
      {...getOverrideProps(overrides, "HealthRecordsFamilyHistory")}
      {...rest}
    >
      <Heading
        width="unset"
        height="unset"
        shrink="0"
        level="3"
        children="Family History"
        {...getOverrideProps(overrides, "Heading")}
      ></Heading>
      <CommentCard
        display="flex"
        gap="16px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="16px 16px 16px 16px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "fhCommentCardPerson1")}
      ></CommentCard>
      <CommentCard
        display="flex"
        gap="16px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="16px 16px 16px 16px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "fhCommentCardPerson2")}
      ></CommentCard>
      <Button
        width="unset"
        height="unset"
        shrink="0"
        size="default"
        isDisabled={false}
        variation="primary"
        children="Add"
        {...getOverrideProps(overrides, "piAdd")}
      ></Button>
    </Flex>
  );
}
